<template>
  <div class="mt-3 w-100">
    <b-col v-if="partDescription" cols="12" class="px-0">
      <learning-unit-part-description-card
        :learning-unit="learningUnit"
        :part="part"
        :disabled="disabled"
        :editable="editable"
      />
    </b-col>

    <b-col v-else-if="editable" cols="12" class="text-right button__add-description">
      <router-link :to="partDescriptionPage">
        <b-button
          :ref="`button__add-description-part-${part}`"
          class="button__add-description"
          variant="outline-primary"
        >
          Add Description
        </b-button>
      </router-link>
    </b-col>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import LearningUnitPartDescriptionCard from '@/components/LearningUnit/LearningUnitPartDescriptionCard';

export default {
  components: {
    LearningUnitPartDescriptionCard
  },
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    part: {
      type: String,
      required: true
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    partDescription() {
      return this.learningUnit.partDescription(this.part);
    },

    partDescriptionPage() {
      return {
        name: 'learning-unit/part/description',
        params: {
          learningUnitId: this.learningUnit.id,
          partType: this.part
        },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.button__add-description {
  max-width: 910px;
  margin: auto;
}
</style>
